import request from '@/utils/request';

export function getWorkIndex() {
  return request({
    url: '/Work/index',
  });
}

export function getWorkList(params, silentRequest = false) {
  return request({
    url: '/Work/explore',
    params,
    silentRequest,
  });
}

export function getWorkDetail(id) {
  return request({
    url: '/Work/detail',
    params: {
      id,
    },
  });
}
